export default __webpack_public_path__ + "static/media/AllEdu.Shop_Logo_v3.384ae614.svg";